import React, { useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

import {
  Background,
  Loading,
  NButton,
  NSearch,
  NTitle,
  Sidebar,
} from '~/components';
import { useApi, useApiEffect, usePlaces } from '~/hooks';
import { postAddress } from '~/services/adress';
import { getGlobalRoute } from '~/services/routes';
import { getDomain } from '~/utils';
import { createTrip as createTripRequest } from '~/services/trips';

import { Container } from './styles';

const Embarkation = () => {
  const { request } = useApi();

  const navigate = useNavigate();

  const { state } = useLocation();

  const embarkation = state?.embarkation;
  const disembarkation = state?.disembarkation;
  const reversed = state?.reversed;
  const routeId = state?.routeId;
  const [globalRoute, setGlobalRoute] = useState();
  const [tripType, setTripType] = useState('TRIPS');

  const { place, searchRef, mapRef, coordinates, isMapLoading } = usePlaces(
    embarkation?.id || globalRoute?.boardingDistrict.id,
    true,
    tripType
  );

  useApiEffect(getGlobalRoute, response => {
    setGlobalRoute(response.data.content[0]);
  });

  const createTrip = data => {
    request(
      () =>
        createTripRequest({
          boardingAddressId: data.id,
          hasReturn: 'no_return',
          landingAddressId: data.id,
          licensedCategoryId: 'ff9a64c7-56c9-4693-9c8e-fdb6e0ff401d',
          passengerId: state.passengerId,
          passengerKms: 1,
          paymentMethod: 0,
          reversed: false,
          routeId: routeId || globalRoute?.id,
          seats: 1,
        }),
      () => navigate(`/${getDomain()}/establishment`)
    );
  };

  const redirect = () => {
    if (!place) {
      return;
    }

    const data = {
      name: place,
      reference: 'Rua',
      latitude: coordinates.lat,
      longitude: coordinates.long,
    };

    request(
      () =>
        postAddress(embarkation?.id || globalRoute?.boardingDistrict.id, data),
      response => {
        if (!state.addressLanding) {
          if (state?.establishment) {
            createTrip(response.data);
            return;
          }
          navigate(`/${getDomain()}/desembarque`, {
            state: {
              disembarkation: disembarkation || globalRoute?.landingDistrict,
              reversed: reversed || false,
              routeId: routeId || globalRoute?.id,
              addressEmbarkation: { ...data, id: response.data.id },
              tripType,
            },
          });
        } else {
          navigate(`/${getDomain()}/horarios`, {
            state: {
              disembarkation: disembarkation || globalRoute?.landingDistrict,
              addressLanding: state.addressLanding,
              reversed: reversed || false,
              routeId: routeId || globalRoute?.id,
              addressEmbarkation: { ...data, id: response.data.id },
            },
          });
        }
      }
    );
  };

  console.log(state);

  return (
    <Container isMapLoading={isMapLoading}>
      <Background />

      <Sidebar />

      <div className="div_top">
        <NTitle
          label="O que você quer hoje?"
          color="white"
          className="title"
          noBack
        />

        <div className="div_top_selector">
          <button
            type="button"
            className="selector_box"
            style={{
              backgroundColor: tripType === 'TRIPS' ? 'white' : undefined,
            }}
            onClick={() => setTripType('TRIPS')}
          >
            <TripIcon color={tripType === 'TRIPS' ? '#4D4D4D' : undefined} />
            <span
              style={
                tripType === 'TRIPS'
                  ? {
                      color: '#4D4D4D',
                    }
                  : undefined
              }
            >
              Viagens
            </span>
          </button>

          <button
            type="button"
            className="selector_box"
            onClick={() => setTripType('DELIVERY')}
            style={{
              backgroundColor: tripType === 'DELIVERY' ? 'white' : undefined,
            }}
          >
            <DeliveryIcon
              color={tripType === 'DELIVERY' ? '#4D4D4D' : undefined}
            />
            <span
              style={
                tripType === 'DELIVERY'
                  ? {
                      color: '#4D4D4D',
                    }
                  : undefined
              }
            >
              Delivery
            </span>
          </button>
        </div>
      </div>

      <NSearch
        ref={searchRef}
        className="nsearch"
        placeholder="Digite o nome da rua:"
        microphone
      />

      <NButton
        className="butonConfir"
        label="Confirmar"
        disabled={!place}
        onClick={redirect}
      />
      <div ref={mapRef} className="map" />
      {isMapLoading && <Loading />}
    </Container>
  );
};

const TripIcon = ({ color }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
  >
    <path
      d="M3.41667 15.3333C4.565 15.3333 5.5 14.3983 5.5 13.25C5.5 12.1017 4.565 11.1667 3.41667 11.1667C2.26833 11.1667 1.33333 12.1017 1.33333 13.25C1.33333 14.3983 2.26833 15.3333 3.41667 15.3333ZM3.41667 12C4.10583 12 4.66667 12.5608 4.66667 13.25C4.66667 13.9392 4.10583 14.5 3.41667 14.5C2.7275 14.5 2.16667 13.9392 2.16667 13.25C2.16667 12.5608 2.7275 12 3.41667 12ZM6.33333 19.0833C6.33333 19.3133 6.14667 19.5 5.91667 19.5C5.68667 19.5 5.5 19.3133 5.5 19.0833C5.5 17.935 4.565 17 3.41667 17C2.26833 17 1.33333 17.935 1.33333 19.0833C1.33333 19.3133 1.14667 19.5 0.916667 19.5C0.686667 19.5 0.5 19.3133 0.5 19.0833C0.5 17.475 1.80833 16.1667 3.41667 16.1667C5.025 16.1667 6.33333 17.475 6.33333 19.0833ZM20.5 14.9167C20.5 16.525 19.1917 17.8333 17.5833 17.8333H8.41667C8.18667 17.8333 8 17.6467 8 17.4167C8 17.1867 8.18667 17 8.41667 17H17.5833C18.7317 17 19.6667 16.065 19.6667 14.9167C19.6667 13.7683 18.7317 12.8333 17.5833 12.8333H9.25C7.64167 12.8333 6.33333 11.525 6.33333 9.91666C6.33333 8.30833 7.64167 7 9.25 7H10.9167C11.1467 7 11.3333 7.18666 11.3333 7.41666C11.3333 7.64666 11.1467 7.83333 10.9167 7.83333H9.25C8.10167 7.83333 7.16667 8.76833 7.16667 9.91666C7.16667 11.065 8.10167 12 9.25 12H17.5833C19.1917 12 20.5 13.3083 20.5 14.9167ZM13.4192 5.6575L12.7008 7.96166C12.6042 8.27083 12.7117 8.60833 12.9717 8.8025C13.1067 8.90416 13.2683 8.955 13.43 8.955C13.5783 8.955 13.7258 8.9125 13.855 8.82583L15.9233 7.44166L18.0267 8.81166C18.1533 8.89416 18.2983 8.935 18.4433 8.935C18.6083 8.935 18.7725 8.88166 18.91 8.77666C19.1675 8.57833 19.2708 8.23916 19.1692 7.93166L18.4217 5.655L20.2292 4.1825C20.4742 3.97583 20.565 3.6375 20.455 3.33583C20.345 3.03416 20.0583 2.83416 19.7375 2.83416H17.445L16.6333 0.557498C16.5225 0.258331 16.2367 0.0599976 15.9175 0.0599976C15.5983 0.0599976 15.3125 0.258331 15.2017 0.557498L14.39 2.83416H12.0975C11.7775 2.83416 11.4908 3.03416 11.3808 3.335C11.27 3.63583 11.3592 3.97333 11.6033 4.18083L13.4192 5.6575ZM14.39 3.66666C14.7425 3.66666 15.0567 3.445 15.175 3.11333L15.9167 1.03083L16.6592 3.11333C16.7775 3.445 17.0917 3.66666 17.4442 3.66666H19.5417L17.8958 5.0075C17.6283 5.22583 17.5225 5.58583 17.6308 5.91333L18.3175 8.00416L16.3792 6.74166C16.2408 6.65166 16.0825 6.60666 15.9242 6.60666C15.7625 6.60666 15.6008 6.65333 15.4608 6.7475L13.55 8.03916L14.2158 5.90416C14.3175 5.57916 14.2108 5.225 13.9467 5.01L12.295 3.66583H14.3917L14.39 3.66666Z"
      fill={color ?? 'white'}
    />
  </svg>
);

const DeliveryIcon = ({ color }) => (
  <svg
    width="21"
    height="21"
    viewBox="0 0 21 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill={color ?? 'white'}
      d="M9.24986 4.66667C10.399 4.66667 11.3332 3.73167 11.3332 2.58333C11.3332 1.435 10.399 0.5 9.24986 0.5C8.10069 0.5 7.16652 1.435 7.16652 2.58333C7.16652 3.73167 8.10069 4.66667 9.24986 4.66667ZM9.24986 1.33333C9.93902 1.33333 10.4999 1.89417 10.4999 2.58333C10.4999 3.2725 9.93902 3.83333 9.24986 3.83333C8.56069 3.83333 7.99986 3.2725 7.99986 2.58333C7.99986 1.89417 8.56069 1.33333 9.24986 1.33333ZM1.74986 9.66667H4.24986C4.93902 9.66667 5.49986 9.10583 5.49986 8.41667V6.75C5.49986 6.42833 5.37486 6.13833 5.17486 5.91667C5.37486 5.695 5.49986 5.405 5.49986 5.08333V3.41667C5.49986 2.7275 4.93902 2.16667 4.24986 2.16667H1.74986C1.06069 2.16667 0.499857 2.7275 0.499857 3.41667V5.08333C0.499857 5.405 0.624857 5.695 0.824857 5.91667C0.624857 6.13833 0.499857 6.42833 0.499857 6.75V8.41667C0.499857 9.10583 1.06069 9.66667 1.74986 9.66667ZM4.66652 8.41667C4.66652 8.64667 4.47902 8.83333 4.24986 8.83333H1.74986C1.52069 8.83333 1.33319 8.64667 1.33319 8.41667V6.75C1.33319 6.52 1.52069 6.33333 1.74986 6.33333H4.24986C4.47902 6.33333 4.66652 6.52 4.66652 6.75V8.41667ZM1.33319 3.41667C1.33319 3.18667 1.52069 3 1.74986 3H4.24986C4.47902 3 4.66652 3.18667 4.66652 3.41667V5.08333C4.66652 5.31333 4.47902 5.5 4.24986 5.5H1.74986C1.52069 5.5 1.33319 5.31333 1.33319 5.08333V3.41667ZM17.9999 14.7092V14.4125C17.9999 14.0017 17.959 13.5883 17.8782 13.185L17.0107 8.85083C16.8165 7.88 15.9565 7.17667 14.9682 7.17667H13.9074L9.39236 5.54417C8.28819 5.31083 7.14986 5.98333 7.16736 7.14083V10.6958C7.16736 11.4783 7.59986 12.1875 8.31402 12.5558L11.0165 13.7792C11.4624 13.9808 11.7507 14.4283 11.7507 14.9175V17.1667H10.084C9.85402 17.1667 9.66736 17.3533 9.66736 17.5833C9.66736 17.8133 9.85402 18 10.084 18H14.7099C14.914 19.41 16.119 20.5 17.584 20.5C19.1924 20.5 20.5007 19.1917 20.5007 17.5833C20.5007 16.1183 19.4099 14.9133 17.9999 14.7092ZM7.99986 10.695V7.14C7.99986 6.9025 8.08069 6.71167 8.23819 6.57333C8.45069 6.3875 8.79569 6.3025 9.15236 6.3425L9.66652 6.52833V12.2533L8.67652 11.805C8.25902 11.5892 7.99986 11.1642 7.99986 10.6942V10.695ZM11.359 13.02L10.4907 12.6275C10.4924 12.6125 10.499 6.83083 10.499 6.83083L13.6907 7.985C13.7365 8.00167 13.784 8.01 13.8324 8.01H14.9665C15.5599 8.01 16.0749 8.4325 16.1924 9.015L17.0599 13.3492C17.1299 13.6992 17.1657 14.0575 17.1657 14.4133V14.71C15.8932 14.8942 14.8924 15.8958 14.7082 17.1675H12.5824V14.9183C12.5824 14.1025 12.1024 13.3575 11.3582 13.0208L11.359 13.02ZM17.5832 19.6675C16.434 19.6675 15.4999 18.7325 15.4999 17.5842C15.4999 16.4358 16.434 15.5008 17.5832 15.5008C18.7324 15.5008 19.6665 16.4358 19.6665 17.5842C19.6665 18.7325 18.7324 19.6675 17.5832 19.6675ZM7.36152 14.66L5.91569 12.3217C5.53319 11.7033 4.87069 11.3342 4.14402 11.3342H0.916523C0.686523 11.3342 0.499857 11.5208 0.499857 11.7508C0.499857 11.9808 0.686523 12.1675 0.916523 12.1675H4.14402C4.57986 12.1675 4.97736 12.3892 5.20652 12.76L5.49736 13.2308C5.10486 13.0908 4.68902 13.0008 4.24902 13.0008C2.18152 13.0008 0.499023 14.6833 0.499023 16.7508C0.499023 18.8183 2.18152 20.5008 4.24902 20.5008C6.31652 20.5008 7.99902 18.8183 7.99902 16.7508C7.99902 15.9792 7.76402 15.2625 7.36319 14.6658C7.36236 14.6642 7.36236 14.6617 7.36069 14.66H7.36152ZM4.24986 19.6675C2.64152 19.6675 1.33319 18.3592 1.33319 16.7508C1.33319 15.1425 2.64152 13.8342 4.24986 13.8342C5.85819 13.8342 7.16652 15.1425 7.16652 16.7508C7.16652 18.3592 5.85819 19.6675 4.24986 19.6675Z"
    />
  </svg>
);

export default Embarkation;
